export const APPLICATION_PROCESS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_title: "Educational Qualification:",
    meta_title_color: "#FFFFFF",
    meta_description: "Bachelor's degree in any discipline from a recognized university with minimum 50% aggregate marks",
    meta_description_color: "#FFFFFFB2",
    meta_priority: 1,
  },

  DEFAULT_ROW_1: {
    id: "1",
    meta_title: "Submit Application",
    meta_title_color: "#222222",
    meta_description: "Complete the online application form and submit required documents",
    meta_description_color: "#000000B2",
    meta_priority: 1,
    meta_box_start_color: "#342B7C",
    meta_box_end_color: "#02A7B6",
    meta_box_gradient_direction: "90deg",
    meta_box_text_color: "#FFFFFF",
  },

  METADATA_TITLES: {
    metadata_1: "Eligibility Criteria",
    metadata_2: "Admission Process",
  },

  APPLICATION_PROCESS_FIELDS_CONFIG: [
    {
      fieldName: "layout_variant",
      label: "Layout Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Layout Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1 (Default)", value: "variant_1" },
        { label: "Variant 2 (Poppins Title)", value: "variant_2" },
      ],
    },
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "Your Path to Global  ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Pre Title",
      required: false,
      defaultValue: "Your Path to Global  ",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#222222CC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pre title color (e.g., #222222CC)",
      required: false,
      defaultValue: "#222222CC",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Financial Planning Excellence",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "Financial Planning Excellence",
    },
    {
      fieldName: "title_start_color",
      label: "Title Start Color (Gradient)",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title gradient start color",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "title_end_color",
      label: "Title End Color (Gradient)",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title gradient end color",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_gradient_direction",
      label: "Title Gradient Direction",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient direction (e.g., 45deg, 90deg)",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "subtitle_1",
      label: "Subtitle 1",
      value: "Eligibility Criteria",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Subtitle 1",
      required: false,
      defaultValue: "Eligibility Criteria",
    },
    {
      fieldName: "subtitle_1_color",
      label: "Subtitle 1 Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subtitle 1 text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "subtitle_1_background_color",
      label: "Subtitle 1 Background Color",
      value: "#56E2F54D",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subtitle 1 background color",
      required: false,
      defaultValue: "#56E2F54D",
    },
    {
      fieldName: "subtitle_2",
      label: "Subtitle 2",
      value: "Admission Process",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Subtitle 2",
      required: false,
      defaultValue: "Admission Process",
    },
    {
      fieldName: "subtitle_2_color",
      label: "Subtitle 2 Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subtitle 2 text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "subtitle_2_background_color",
      label: "Subtitle 2 Background Color",
      value: "#56E2F54D",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subtitle 2 background color",
      required: false,
      defaultValue: "#56E2F54D",
    },
    {
      fieldName: "background_image",
      label: "Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Background Image",
      description: "Recommended size: 336px × 450px (width × height). A different image size may not fit in this widget.",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_background_image",
      label: "Alt Text for Background Image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "box_start_color",
      label: "Box Gradient Start Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter box gradient start color",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "box_end_color",
      label: "Box Gradient End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter box gradient end color",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "gradient_direction",
      label: "Box Gradient Direction",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient direction (e.g., 45deg, to right)",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "status",
      label: "Application Process Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Application Process",
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS_1: [
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title (e.g., Eligibility Criteria)",
      required: true,
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title Color",
      required: false,
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: true,
    },
    {
      header: "Description Color",
      fieldName: "meta_description_color",
      value: "#FFFFFFB2",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Description Color",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],

  METADATA_FIELDS_2: [
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title (e.g., Admission Process)",
      required: true,
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title Color",
      required: false,
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: true,
    },
    {
      header: "Description Color",
      fieldName: "meta_description_color",
      value: "#000000B2",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Description Color",
      required: false,
    },
    {
      header: "Box Gradient Start Color",
      fieldName: "meta_box_start_color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter box gradient start color",
      required: false,
    },
    {
      header: "Box Gradient End Color",
      fieldName: "meta_box_end_color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter box gradient end color",
      required: false,
    },
    {
      header: "Box Gradient Direction",
      fieldName: "meta_box_gradient_direction",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient direction (e.g., 90deg, 45deg)",
      required: false,
    },
    {
      header: "Box Text Color",
      fieldName: "meta_box_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter box text color",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],
};
